import styled from "styled-components";

export const ButtonIcon = styled.button`
    border: none;
    background: none;
    width: 12vw;
    max-width: 140px;
    height: 13vh;
    max-height: 140px;
    margin: 5vw;
    font-family: 'Source Code Pro',monospace;
    font-weight: bold;
    font-size: 1.2rem;

    @media (max-width: 768px) {
        width: 25vw;
        min-width: 70px; 
        height: 18vh;
        min-height: 70px;
        margin: 20px;
    }  
`;